import Money from "./Money"
import { useState } from "react"
import { FiChevronDown } from "react-icons/fi"
import { FeeLine } from "../../utils/applicationFees"

export default function FeeSummary({
  serviceLines,
  officialLines,
  subtotalServices,
  subtotalOfficial,
  total,
  title = "Total Fees"
}: {
  serviceLines: FeeLine[]
  officialLines: FeeLine[]
  subtotalServices: number
  subtotalOfficial: number
  total: number
  title?: string
}) {
  return (
    <section className="px-6 py-4 sm:px-8">
      <div className="mb-4 flex items-center justify-between gap-4">
        <span className="text-sm font-semibold text-gray-900">{title}</span>
        <span className="text-sm font-semibold tabular-nums text-gray-900">
          <Money amount={total} />
        </span>
      </div>
      <div className="divide-y divide-gray-200 border-y border-gray-200">
        <FeeCategory title="Service Fees" lines={serviceLines} subtotal={subtotalServices} />
        <FeeCategory title="Official Fees" lines={officialLines} subtotal={subtotalOfficial} />
      </div>
    </section>
  )
}

function FeeCategory({
  title,
  lines,
  subtotal
}: {
  title: string
  lines: FeeLine[]
  subtotal: number
}) {
  const [open, setOpen] = useState(false)

  return (
    <section className="py-3">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between gap-3 text-left"
        aria-expanded={open}
      >
        <span className="text-sm font-semibold text-gray-900">{title}</span>
        <span className="flex shrink-0 items-center gap-2">
          <span className="text-xs text-gray-500">Subtotal</span>
          <span className="text-sm font-medium tabular-nums text-gray-700">
            <Money amount={subtotal} />
          </span>
          <FiChevronDown
            className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
            aria-hidden="true"
          />
        </span>
      </button>
      {open && (
        <div className="mt-3 space-y-2">
          {lines.map((line, index) => (
            <div key={`${line.label}-${index}`} className="flex justify-between gap-4 text-sm text-gray-600">
              <span>{line.label}</span>
              <span className="shrink-0 tabular-nums"><Money amount={line.amount} /></span>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
